module.exports = __webpack_public_path__ + "media/qdaz.28667e79.mp4";